import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'mediaLibraryModal',
    'mediaList',
    'mediaLibraryTabLink',
    'mediaListPage',
    'mediaRows',
    'uploadTab'
  ]
  static values = {
    mediaIndexUrl: String,
    filter: { type: String, default: '' },
    filterType: { type: String, default: '' },
    currentMediaType: { type: String, default: '' }
  }

  connect() {
    this.isLoading = false
  }

  async handleShowGallery({ detail: { mediaType } }) {
    this.currentMediaType = mediaType
    this.target = event.target
    this.currentPage = 1

    await this.reloadUploadTab(mediaType)

    this.mediaListTarget.innerHTML = await this.loadGallery()
    $(this.mediaLibraryModalTarget).modal('show')
  }

  async reloadUploadTab(mediaType) {
    const url = new URL(this.mediaIndexUrlValue, window.location.origin)
    url.searchParams.set('render_upload_tab', 'true')
    url.searchParams.set('media_type', mediaType)

    try {
      const response = await fetch(url, { method: 'GET' })
      const html = await response.text()
      this.uploadTabTarget.innerHTML = html
    } catch (error) {
      console.error('Error reloading upload tab:', error)
    }
  }

  async refreshMediaList() {
    this.currentPage = 1
    this.mediaListTarget.innerHTML = await this.loadGallery()
    $(this.mediaLibraryTabLinkTarget).tab('show')
  }

  async filter(event) {
    this.filterTypeValue = event.params.filterType
    this.filterValue = event.currentTarget.value
    this.currentPage = 1
    this.mediaListTarget.innerHTML = await this.loadGallery()
  }

  selectAsset({ params: { assetUrl, assetId, assetEditUrl, assetName, assetIsImage } }) {
    this.dispatch(
      'selectAsset',
      {
        detail: {
          assetUrl: assetUrl,
          assetId: assetId,
          assetEditUrl: assetEditUrl,
          assetName: assetName,
          assetIsImage: assetIsImage,
          target: this.target
        }
      }
    )
    $(this.mediaLibraryModalTarget).modal('hide')
  }

  async handleScroll(event) {
    const element = event.currentTarget

    if (element.dataset.hasMorePages === 'false') return
    if (this.isLoading) return;

    if (element.scrollTop + element.offsetHeight + 100 > this.mediaRowsTarget.offsetHeight) {
      await this.loadMore(element)
    }
  }

  async loadMore(element) {
    this.isLoading = true
    this.currentPage = this.currentPage + 1

    const html = await this.loadGallery()

    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html

    const newMediaList = tempDiv.querySelector('.media-list')
    if (newMediaList) {
      element.dataset.hasMorePages = newMediaList.dataset.hasMorePages
      this.currentPage = parseInt(newMediaList.dataset.currentPage)

      const newMediaItems = newMediaList.querySelector('.row')
      const existingRow = element.querySelector('.row')

      if (newMediaItems && existingRow) {
        Array.from(newMediaItems.children).forEach(child => {
          existingRow.appendChild(child)
        })
      }
    }

    this.isLoading = false
  }

  async loadGallery() {
    const url = new URL(this.mediaIndexUrlValue, window.location.origin)
    url.searchParams.set('render_as_modal', 'true')
    url.searchParams.set('media_type', this.currentMediaType)
    url.searchParams.set('page', this.currentPage)

    if (this.filterValue) {
      url.searchParams.set(this.filterTypeValue, this.filterValue)
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
      })
      return response.text()
    } catch (error) {
      console.error(error)
    }
  }
}
